import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../UI/SectionHeading';
import { APPROACH } from '../../constants';

const Approach: React.FC = () => {
  return (
    <section id='approach' className='scroll-mt-20 max-w-7xl mx-auto px-5 sm:px-6'>
      <SectionHeading
        index='01'
        kicker='Approach'
        title='How I work, inside the business'
        description='Transformation succeeds when someone owns the gap between strategy and the desk where work happens. That is where I operate.'
      />

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3'>
        {APPROACH.map((item, i) => (
          <motion.div
            key={item.step}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: i * 0.09, ease: [0.16, 1, 0.3, 1] }}
            className='group relative flex flex-col rounded-2xl bg-surface p-6 sm:p-7 min-h-[260px] overflow-hidden transition-colors duration-500 hover:bg-ink'
          >
            <span className='label-mono text-gray2 group-hover:text-gray2 transition-colors duration-500'>
              [ {item.step} ]
            </span>

            <h3 className='mt-auto pt-10 font-medium tracking-tight text-xl text-ink group-hover:text-paper transition-colors duration-500'>
              {item.title}
            </h3>
            <p className='mt-3 text-sm leading-relaxed text-gray1 group-hover:text-gray2 transition-colors duration-500'>
              {item.description}
            </p>

            {/* Accent tick on hover */}
            <span className='absolute top-6 right-6 h-2 w-2 rounded-full bg-line group-hover:bg-accent transition-colors duration-500' />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Approach;
